module.exports = __webpack_public_path__ + "img/new_footer_qrcode1.84f2f9ce.png";